// general input masks
$('.cepMask').mask("99999-999");
$('.cpfMask').mask("999.999.999-99");
$('.dataMask').mask("99/99/9999");
$('.foneMask').focusout(function () {
    var phone, element;
    element = $(this);
    element.unmask();
    phone = element.val().replace(/\D/g, '');
    if (phone.length > 10) {
        element.mask("(99) 99999-999?9");
    } else {
        element.mask("(99) 9999-9999?9");
    }
}).trigger('focusout');
$(document).on('change','#formContato_estado',function(){
    var uf = $(this).val();
    $("#formContato_cidade").html('<option>Carregando cidades...</option>');
    $.ajax({
        type: "POST",
        data: {uf: uf},
        url: "ajax-cidades.php",
        success: function (result) {
            $("#formContato_cidade").html(result);
        }
    });
});

// for specific pages
if ($('#page_cerveja').length) {
    // Swiper
    var swiper__premiacoesCervejas = new Swiper('.swiper__premiacoesCervejas__hero', {
        slidesPerView: 'auto',
        spaceBetween: 40,
        autoplay: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });

    // Float beer
    $(window).on('scroll', function() {

        console.clear();

        var el = $('.beer__floatProduct');

       useFullProps = {
           offsetTopEl: el.offset().top,
           scrollEfetuado: $(window).scrollTop(),
           heightContent: $('.beer__infos').height(),
           heightEl: el.height(),
       }

       console.log(useFullProps);
       
       var setTopToEl = useFullProps.scrollEfetuado - 80;

       if (useFullProps.scrollEfetuado >= 100) {
           el.css('top', setTopToEl);
       }
       
       if (useFullProps.scrollEfetuado > useFullProps.heightContent - useFullProps.heightEl + 70) {
           el.css('top', useFullProps.heightContent - useFullProps.heightEl);
       }

       console.log(useFullProps.heightContent - useFullProps.heightEl + 70);

    });

    // swiper - float beer
    var swiper__floatProducts = new Swiper('.swiper__floatProducts', {
        speed: 500,
        slidesPerView: 1,
        autoplay: true,
        watchOverflow: true,
        loop: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 0,
        breakpoints: {
            570: {
                autoHeight: true,
                /*loop: false,*/
            }
        }
    });

}
if ($('#page_trabalheConosco').length) {
    $('#formRH_anexo--hidden').on('change', function() {
        var t = $(this).val().split('fakepath');
        $('#formRH_anexo').attr('placeholder', t[1]);
    });

    $("#formTrabalhe").validate({
        submitHandler: function (form) {
            //SUBMIT form
            $(form).ajaxSubmit({
                //target: 'status-envio',
                beforeSubmit: function () {
                    $('#status-envio').show();
                    $('#status-envio').html('<span class="c-stsSend__feedback c-stsSend__feedback--load"> Enviando, aguarde...</span>');
                    $('#btnTrabalhe').attr('disabled', true);
                },
                success: function (result) {
                    result = result.split('|');
                    if(parseInt(result[0].charAt(result[0].length-1)) == 1){
                        $('#status-envio').html(result[1]);
                        setTimeout(function(){
                            $('#btnTrabalhe').attr('disabled',false);
                            $("#formTrabalhe .field").val('');
                            $("#formTrabalhe textarea").val('').html('');
                            $("#formRH_anexo").attr('placeholder','Selecione seu currículo');
                            $("#formTrabalhe .field").removeClass('error');
                            $('#status-envio').hide();
                            $('#status-envio').empty();
                        },2000);
                    }else{
                        $('#status-envio').html(result);
                        setTimeout(function () {
                            $('#status-envio').hide();
                            $('#status-envio').empty();
                            $('#btnTrabalhe').attr('disabled', false);
                        }, 3000);
                    }
                }
            });
        }
    });
}
if ($('#page_empresa').length) {
    var hashPage = window.location.hash;
    $('.linkToSection--visitas').on('click', function() {
        goToSection__scroll('#page_empresa--visitas');
    });
    if (hashPage == '#visitas') {
        goToSection__scroll('#page_empresa--visitas');
    }

    $("#formVisitas").validate({
        submitHandler: function (form) {
            //SUBMIT form
            $(form).ajaxSubmit({
                //target: 'status-envio',
                beforeSubmit: function () {
                    $('#status-envio').show();
                    $('#status-envio').html('<span class="c-stsSend__feedback c-stsSend__feedback--load"> Enviando, aguarde...</span>');
                    $('#btnVisitas').attr('disabled', true);
                },
                success: function (result) {
                    result = result.split('|');
                    if(parseInt(result[0].charAt(result[0].length-1)) == 1){
                        $('#status-envio').html(result[1]);
                        setTimeout(function(){
                            $('#btnVisitas').attr('disabled',false);
                            $("#formVisitas .field").val('');
                            $("#formVisitas textarea").val('').html('');
                            $("#formVisitas .field").removeClass('error');
                            $('#status-envio').hide();
                            $('#status-envio').empty();
                        },2000);
                    }else{
                        $('#status-envio').html(result);
                        setTimeout(function () {
                            $('#status-envio').hide();
                            $('#status-envio').empty();
                            $('#btnVisitas').attr('disabled', false);
                        }, 3000);
                    }
                }
            });
        }
    });
}
/*if ($('#page_ondeEncontrar').length) {
    $('#page_ondeEncontrar--search button').on('click', function(event){
        event.preventDefault();
        goToSection__scroll('#page_ondeEncontrar--results');
    });
}*/
if ($('#page_downloads').length) {
    $('.categoryDownload h3').on('click', function(){
        $(this).toggleClass('is-active');
        $(this).parent().children('.listDownload').toggleClass('is-active');
    });
}
if ($('#page_distribuidor').length) {
    $("#formDistribuidor").validate({
        submitHandler: function (form) {
            //SUBMIT form
            $(form).ajaxSubmit({
                //target: 'status-envio',
                beforeSubmit: function () {
                    $('#status-envio').show();
                    $('#status-envio').html('<span class="c-stsSend__feedback c-stsSend__feedback--load"> Enviando, aguarde...</span>');
                    $('#btnDistribuidor').attr('disabled', true);
                },
                success: function (result) {
                    result = result.split('|');
                    if(parseInt(result[0].charAt(result[0].length-1)) == 1){
                        $('#status-envio').html(result[1]);
                        setTimeout(function(){
                            $('#btnDistribuidor').attr('disabled',false);
                            $("#formDistribuidor .field").val('');
                            $("#formDistribuidor textarea").val('').html('');
                            $("#formDistribuidor .field").removeClass('error');
                            $('#status-envio').hide();
                            $('#status-envio').empty();
                        },2000);
                    }else{
                        $('#status-envio').html(result);
                        setTimeout(function () {
                            $('#status-envio').hide();
                            $('#status-envio').empty();
                            $('#btnDistribuidor').attr('disabled', false);
                        }, 3000);
                    }
                }
            });
        }
    });
}
if ($('#page_contato').length) {
    $("#formContato").validate({
        submitHandler: function (form) {
            //SUBMIT form
            $(form).ajaxSubmit({
                //target: 'status-envio',
                beforeSubmit: function () {
                    $('#status-envio').show();
                    $('#status-envio').html('<span class="c-stsSend__feedback c-stsSend__feedback--load"> Enviando, aguarde...</span>');
                    $('#btnContato').attr('disabled', true);
                },
                success: function (result) {
                    result = result.split('|');
                    if(parseInt(result[0].charAt(result[0].length-1)) == 1){
                        $('#status-envio').html(result[1]);
                        setTimeout(function(){
                            $('#btnContato').attr('disabled',false);
                            $("#formContato .field").val('');
                            $("#formContato textarea").val('').html('');
                            $("#formContato .field").removeClass('error');
                            $('#status-envio').hide();
                            $('#status-envio').empty();
                        },2000);
                    }else{
                        $('#status-envio').html(result);
                        setTimeout(function () {
                            $('#status-envio').hide();
                            $('#status-envio').empty();
                            $('#btnContato').attr('disabled', false);
                        }, 3000);
                    }
                }
            });
        }
    });
}
if ($('#page_denuncia').length) {
    // $('#formDenunciaFile--hidden').on('change', function() {
    //     var t = $(this).val();
    //     console.log(t)
    //     $('#formDenunciaFile').attr('placeholder', t);
    // });

    var myDropZone = $("div#dropzoneFiles").dropzone({
        url: "envia-upload",
        maxFiles: 5,
        maxFilesize: 2,
        parallelUploads : 5,
        clickable: true,
        addRemoveLinks: true,
        uploadMultiple: true,
        autoProcessQueue: false,
        acceptedFiles: 'image/*',
        dictInvalidFileType: 'Formato de arquivo não permitido'
    });

    $("#formDenuncia").validate({
        submitHandler: function (form) {
            //SUBMIT form
            $(form).ajaxSubmit({
                //target: 'status-envio',
                beforeSubmit: function () {
                    $('#status-envio').show();
                    $('#status-envio').html('<span class="c-stsSend__feedback c-stsSend__feedback--load"> Enviando, aguarde...</span>');
                    $('#btnDenuncia').attr('disabled', true);
                },
                success: function (result) {
                    result = result.split('|');
                    if(parseInt(result[0].charAt(result[0].length-1)) == 1){
                        $('#status-envio').html(result[1]);
                        var numFiles = 0;
                        if($("div#dropzoneFiles").length){
                            var myDropZone = Dropzone.forElement("div#dropzoneFiles");
                            numFiles = myDropZone.files.length;
                        }
                        if(numFiles > 0){
                            myDropZone.processQueue();
                            myDropZone.on("complete", function(file) {
                                myDropZone.removeFile(file);
                                setTimeout(function(){
                                    $('#btnDenuncia').attr('disabled',false);
                                    $("#formDenuncia .field").val('');
                                    $("#formDenuncia textarea").val('').html('');
                                    $("#formDenuncia .field").removeClass('error');
                                    $('#status-envio').hide();
                                    $('#status-envio').empty();
                                },2000);
                            });
                        }else{
                            setTimeout(function(){
                                $('#btnDenuncia').attr('disabled',false);
                                $("#formDenuncia .field").val('');
                                $("#formDenuncia textarea").val('').html('');
                                $("#formDenuncia .field").removeClass('error');
                                $('#status-envio').hide();
                                $('#status-envio').empty();
                            },2000);
                        }
                    }else{
                        $('#status-envio').html(result);
                        setTimeout(function () {
                            $('#status-envio').hide();
                            $('#status-envio').empty();
                            $('#btnDenuncia').attr('disabled', false);
                        }, 3000);
                    }
                }
            });
        }
    });
}